import React, { Component } from 'react';
import { arrayOf, shape, string, func, any } from 'prop-types';
import { DESC } from '../../../BaseDataTable';
import { Tooltip } from '@material-ui/core';
import { ArrowUpward, ArrowDownward, Info as InfoIcon } from '@material-ui/icons';
import classNames from 'classnames';
import styles from './styles.scss';

export default class WebTableHeader extends Component {
  static propTypes = {
    headers: arrayOf(shape({
      title: string,
      key: string
    })),
    onCellClick: func,
    headerTooltipText: string,
    adsTooltipText: string,
    sortKey: string,
    sortStatus: shape({any}),
    iconKey: string
  }

  static defaultProps = {
    headerTooltipText: 'Sort',
    adsTooltipText: 'Recommended 50+ ads for statistical relevance',
    iconKey: 'ads'
  }

  drawArrowIcon() {
    const { sortKey, sortStatus } = this.props;
    const arrowIcon = sortStatus[sortKey] === '' ||
                      sortStatus[sortKey] === DESC ?
                      <ArrowDownward className={styles.arrowIcon}/> :
                      <ArrowUpward className={styles.arrowIcon}/>;
    return <span>{arrowIcon}</span>
  }

  drawTableHeader() {
    const { headers, sortKey, onCellClick, headerTooltipText, adsTooltipText, iconKey } = this.props;
    return headers && headers.map(header => {
      const { title, key } = header;
      const arrowIcon = sortKey === key && this.drawArrowIcon();
      if(title && key) {
        return (
          <div className={styles.tableCell} key={key} onClick={onCellClick(key)}>
            {arrowIcon}
              <div>
                <Tooltip title={headerTooltipText} placement="top-start">
                  <span data-test="tableHeaderTitle" >{title}</span>
                </Tooltip>
              {key === iconKey &&
                <Tooltip title={adsTooltipText} placement="top-start" data-test="webAdsToolTip">
                  <InfoIcon className={styles.infoIcon} data-test="webAdsIconInfo"/>
                </Tooltip>}
              </div>
          </div>
        )
      }
    })
  }

  render() {
    const tableHeaderCell = this.drawTableHeader();
    return(
      <div className={classNames(styles.tableRow, styles.tableHeader)}>
        {tableHeaderCell}
      </div>
    )
  }
}